export const en = {
    icon: {
        'SME': 'mdi-factory',
        'MIKRO': 'mdi-account-group'
    },
    msg:{

        'brNumber_error_required': 'Please enter BR Number',
        'officerName_error_required': 'Please enter officer name',
        'officerId_error_required': 'Please enter officer id',

        'businessCategory_error_required': 'Please select business category',
        'gender_error_required': 'Please select gender',
        'ethnicity_error_required': 'Please select gender',
        'employeesCount_error_required': 'Please enter number of employees',

        'applicationNumber_error_required': 'Please enter customer\'s application number.',
        'applicationNumber_error_max': 'Maximum length should be less than 10 digits.',
        'applicationNumber_error_numeric': 'Only numbers are allowed.',
        'applicationNumber_error_alpha_num': 'Only alphabets and numbers are accepted.',
        'applicationNumber_error_0': 'Application Number already exists',

        'fullName_error_required': 'Please enter customer\'s full name as indicated on their NRIC.',
        'fullName_error_min': 'Full Name must be at least 5 characters long.',
        'fullName_error_regex': 'Only letters of the alphabet, spaces, and the following special characters: @ ’ - and / are accepted.',
        'fullName_error_max': 'Full Name cannot be longer than 80 characters.',

        'position_error_min': 'Minimum length should be at least 2 characters.',
        'position_error_max': 'Maximum length should be less than 10 characters.',
        'position_error_required': 'Please enter customer\'s position.',
        'position_error_regex': 'Only alphabet, spaces, numerals, and the following special characters: . - & () and ’ are accepted.',

        'companyName_error_required': 'Please enter customer\'s company name.',
        'companyName_error_min': 'Company name must be at least 5 characters long.',
        'companyName_error_regex': 'Only alphabet, spaces, numerals, and the following special characters: . - & () and ’ are accepted.',
        'companyName_error_max': 'Company name must not be longer than 80 characters.',

        'annualSales_error_required': 'Please enter customer\'s  annual sales.',
        'annualSales_error_numeric': 'Only numbers are allowed.',
        'annualSales_error_max_value': 'The maximum entry is 999999999.',
        'annualSales_error_min_value': 'The minimum entry is 0.',

        'annualProfit_error_required': 'Please enter customer\'s  annual profit.',
        'annualProfit_error_numeric': 'Only numbers are allowed.',
        'annualProfit_error_max_value': 'Annual profit cannot be greater than annual sales.',
        'annualProfit_error_min_value': 'The minimum entry is 0.',

        'financingAmount_error_required': 'Please enter financing amount.',
        'financingAmount_error_max_value': 'The maximum entry is 5000000.',
        'financingAmount_error_min_value': 'The minimum entry is 20000.',
        'financingAmount_error_numeric': 'Only numbers are allowed.',

        'tenureApplied_error_required': 'Please enter tenure applied.',
        'tenureApplied_error_max_value': 'The maximum entry is 240.',
        'tenureApplied_error_min_value': 'The minimum entry is 12.',
        'tenureApplied_error_numeric': 'Only numbers are allowed.',

        'financingAmountApproved_error_required': 'Please enter financing amount approved.',
        'financingAmountApproved_error_numeric': 'Only numbers are allowed.',
        'financingAmountApproved_error_min_value': 'The minimum entry is {0}.',
        'financingAmountApproved_error_max_value': 'The maximum entry is {1}.',

        'tenureApproved_error_numeric': 'Only numbers are allowed.',
        'tenureApproved_error_required': 'Please enter tenure approved.',
        'tenureApproved_error_max_value': 'The maximum entry is {1}.',
        'tenureApproved_error_min_value': 'The minimum entry is {0}.',

        'employeesCount_error_numeric': 'Only numeric values are accepted',
        'employeesCount_error_min_value': 'The number of full-time employees must be at least 1.',
        'employeesCount_error_max_value': 'The number of full-time employees must not exceed 100,000.',

        'facility_error_required': 'Please select facility',

        'officerId_error_numeric': 'Only numbers are allowed.',
        'officerId_error_min': 'The ID must be at least 4 characters long.',
        'officerId_error_max': 'The ID number cannot be longer than 6 characters.',

        'officerName_error_regex': 'Only alphabet, spaces, and the following special characters: @ ’ - and / are accepted',
        'officerName_error_min': 'The name must be at least 5 characters long.',
        'officerName_error_max': 'The name cannot be longer than 80 characters.',

        'ctosRating_error_max': 'Cannot be more than 100 characters',
        'ctosRating_error_required': 'Please enter CTOS score of the customer.',
        'ctosRating_error_numeric': 'Numeric values only',
        'ctosRating_error_min_value': 'The minimum value should be greater than 300',
        'ctosRating_error_max_value': 'The maximum value should not be greater than 850',

        'ccrisRating_error_required': 'Please enter CCRIS score of the customer.',
        'ccrisRating_error_numeric': 'Numeric values only',
        'ccrisRating_error_min_value': 'The minimum value should be greater than 0',
        'ccrisRating_error_max_value': 'The maximum value should not be greater than 999',

        'internalRating_error_required': 'Please enter internal credit rating of the customer.',
        'internalRating_error_min': 'The rating must be at least 5 characters long.',
        'internalRating_error_max': 'The rating cannot be longer than 10 characters.',
        'internalRating_error_regex': 'The only acceptable characters are letters of the alphabet, numeral, space and the following special characters: + - # and @',

        'idNumber_error_required': 'Please enter the ID Number',



            // Login
            'username_error_required': 'Please enter your username',
            'password_error_required': 'Please enter your password',



            serverError: 'Unknown Error has occurred. Please contact support.',
            general_serverError: 'Unknown Error has occurred. Please contact support.',
            username_used: 'The user name has been used. Please use a new one',
            SMS_error_required: 'Please enter the number to which the credentials will be delivered.',
            Email_error_required: 'Please enter the Email Address to which the credentials will be delivered.',
        Email_error_email: 'Please enter the email in the correct format.',
        'product_error_required': 'Please choose the programme',
        'general_repeating_user': 'This user exist and within the time frame.',
        'country_error_required': 'Please select country',

            // Dashboard
            'export_button': 'Export',

            // Headers
            'sl_no': 'No.',
            'verification_code': 'Verification Code',
            'application_number': 'Application No.',
            'br_number': 'Business Registration (BR) No.',
            'company_name': 'Company Name',
            'id_number': 'Identification Number (ID)',
            'business_category': 'Business Category',
            'staff_name': 'Relationship Manager',
            'supervisor_name':'Supervisor',
            'branch': 'State',
            'region': 'Region',
            'scheme': 'Programme',
            'financing_amount_requested': 'Financing Amount',
            'tenure_applied': 'Tenure',
            'assessment_type': 'Assessment Type',
            'gfi_status': 'GFI Status',
            'gfi_registration_date': 'GFI Registration Date',
            'gfi_completion_date': 'GFI Completion Date',
            'update_details': 'Update Details',
            'gfi_scoring': 'GFI Scoring',
            'application_status': 'Application Status',
            'report': 'Report',
            'expiry_date': 'GFI Expiry Date',
            'f1': 'F1',
            'f2': 'F2',
            'f3': 'F3',
            'gfi_rating': 'GFI Rating',
            'credit_score': 'GFI Score',
            'access_id': 'Access Id',

            // Dropdowns
            'scheme_label': 'Programme',
            'amount_label': 'Financing Amount Range',
            'status_label': 'GFI Status',
            'applicationStatus_label': 'Financing Application Status',
            'date_label': 'Date',
            'start_date': 'Start Date',
            'end_date': 'End Date',
            'branch_label': 'State',
            'region_label': 'Region',
            'fficer_label': 'Relationship Manager',
        'supervisor_label': 'Supervisor',
        'officer_label': 'Relationship Manager',
            'report_unavailable': 'Please wait while the report is being generated.<br>If the problem persists please contact support',
            'export_unavailable': 'We encountered an error while exporting data , please try again.<br>If the problem persists please contact support',
            'close_label': 'Close',
            'scheme_all_applied': 'All Programmes',
            'amount_all_applied': 'All Amount Ranges',
            'gfiStatus_all_applied': 'All Status',
            'rmOfficer_all_applied': 'All Relationship Managers',
        'supervisor_all_applied': 'All Supervisors',
        'status_all_applied': 'All Status',
            'applicationStatus_all_applied': 'All Financing Application Status',
            'region_all_applied': 'All Regions',
        'officer_all_applied': 'All Relationship Managers',

        'malaysianOwned_error_required':'Select an option',
        'date_error_required':'Select a date',
        'natureofbusiness_error_required':'Select an option',
            // TimeOut Dialog
            'session_expire_heading': 'Session Expiration Warning',
            'session_expire_message_1': 'Your session will expire in',
            'session_expire_message_2': 'seconds. Please click “Continue” to continue your session or click “Log Out Now” to end your session now.',

            'table_heading_export': 'Data Export History',
            'table_header_no': 'No.',
            'table_header_date': 'Export Date',
            'table_header_finance_type': 'Finance Type',
            'table_header_filter_applied': 'Filters Applied',
            'table_header_status': 'Status',
            'table_header_download': 'Download'
        }
}
